import { v, type Infer } from "convex/values";

export const SIGN_IN_LINK_FLOWS = ["modal", "listing_quote"] as const;

export const signInLinkFlowValidator = v.union(
  ...SIGN_IN_LINK_FLOWS.map((flow) => v.literal(flow)),
);

export type SignInLinkFlow = Infer<typeof signInLinkFlowValidator>;

export const signInLinkValidator = v.object({
  returnPath: v.string(),
  flow: signInLinkFlowValidator,
});

export type SignInLink = Infer<typeof signInLinkValidator>;
